import { requireAuth } from '@/auth/requireAuth'
import { getColumns } from '@/components/tasks/admin-task-columns'
import { PageTitle } from '@/layout/page-title'
import { createFileRoute, Link, useLoaderData } from '@tanstack/react-router'
import { getTasksProps } from '@/tasks'
import { MonthSelectorWrapper } from '@/components/month-selector-wrapper'
import { Button } from '@/components/ui/button'
import { getClosingDate } from '@/utils/closing-date'
import { DataTable } from '@/components/tasks/task-data-table'
export const Route = createFileRoute('/(app)/_layout/manage-tasks')({
  component: RouteComponent,
  beforeLoad: requireAuth,
  validateSearch: () => ({}) as { month?: number; year?: number },
  loaderDeps: ({ search: { month, year } }) => {
    const closingDate = getClosingDate();
    return {
      month: month ?? closingDate.month, // Default to current month if not provided
      year: year ?? closingDate.year, // Default to current year if not provided
    };
  },
  pendingComponent: () => <div className="text-center">Loading tasks...</div>,
  pendingMs: 500,
  loader: async ({ deps }) => {
    const { month, year } = deps;
    const props = await getTasksProps();

    return { props, month, year };
  },
})

function RouteComponent() {

  const { props, month, year } = useLoaderData({ from: '/(app)/_layout/manage-tasks' });

  const { data: taskProps, error: propsError } = props;

  if (propsError) {
    console.error("Error loading tasks:", propsError);
    throw new Error("Failed to load tasks: " + propsError);
  }

  // Generate columns with props
  const columns = getColumns(taskProps ?? undefined);

  return (

    <div className="container max-w-[1900px] py-4 px-4 mx-auto">
      <div className="space-y-4">

        <PageTitle title="Manage Tasks" rightActions={
          <div className="flex items-center gap-4">
            <div className="max-w-[350px]">
              <MonthSelectorWrapper initialMonth={month} initialYear={year} />
            </div>
            <Button asChild>
              <Link to="/tasks/create" className="text-sm">
                Add Task
              </Link>
            </Button>
          </div>
        } />

        <DataTable
          excludeNotApplicable={false}
          month={month}
          year={year}
          source="all"
          columns={columns}
        />
      </div>
    </div>
  )
}
